package de.connect2x.timmy.customcomponents

import de.connect2x.timmy.customcomponents.roomHeaderWithArchiveButton.RoomHeaderWithArchiveButtonViewModelWcImpl
import de.connect2x.trixnity.core.model.RoomId
import de.connect2x.trixnity.core.model.UserId
import de.connect2x.trixnity.messenger.extensions.tim.roomdetails.TIMRoomHeaderViewModelImpl
import de.connect2x.trixnity.messenger.viewmodel.MatrixClientViewModelContext
import de.connect2x.trixnity.messenger.viewmodel.room.timeline.RoomHeaderViewModel
import de.connect2x.trixnity.messenger.viewmodel.room.timeline.RoomHeaderViewModelFactory
import de.connect2x.trixnity.messenger.viewmodel.room.timeline.RoomHeaderViewModelImpl

object RoomHeaderViewModelFactoryWcImpl: RoomHeaderViewModelFactory {
    override fun create(
        viewModelContext: MatrixClientViewModelContext,
        selectedRoomId: RoomId,
        onBack: () -> Unit,
        onVerifyUser: () -> Unit,
        onOpenRoomSettings: () -> Unit,
        onOpenUserProfile: (UserId) -> Unit,
    ): RoomHeaderViewModel =
        RoomHeaderWithArchiveButtonViewModelWcImpl(
            viewModelContext,
            selectedRoomId,
            timRoomHeaderViewModel =
                TIMRoomHeaderViewModelImpl(
                    viewModelContext,
                    selectedRoomId,
                    RoomHeaderViewModelImpl(
                        viewModelContext = viewModelContext,
                        selectedRoomId = selectedRoomId,
                        onBack = onBack,
                        onVerifyUser = onVerifyUser,
                        onOpenRoomSettings = onOpenRoomSettings,
                        onOpenUserProfile = onOpenUserProfile,
                    )
                ),
        )
}
